import { SBBox, SBTypography } from "modules/Commons";
import SBConfirmDialog from "modules/Commons/SBForms/SBConfirmDialog";
import distributionConfirm from "assets/logistics.svg";
import { useTranslation } from "react-i18next";

export default ({
	open,
	onClose,
	onConfirm,
	onCancel,
	loading,
}: {
	open: boolean;
	onClose: () => any;
	onConfirm: () => any;
	onCancel: () => any;
	loading?: boolean;
}) => {
	const { t } = useTranslation();
	return (
		<SBConfirmDialog
			key={open + ""}
			open={open}
			title={t("transferenceConfirmationTitle")}
			onConfirm={onConfirm}
			onCancel={onCancel}
			onClose={onClose}
			confirmColor="primary"
			loading={loading}
		>
			<SBBox display="flex" flexDirection="column" width="25rem">
				<SBBox mx="auto">
					<img height={140} width={190.21} src={distributionConfirm} />
				</SBBox>
				<SBTypography mt="1.5rem" color="blackTitle.main">
					{t("transferenceConfirmationText")}
				</SBTypography>
			</SBBox>
		</SBConfirmDialog>
	);
};
